module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    '+
((__t=( type.name ))==null?'':__t)+
': '+
((__t=( child.name ))==null?'':__t)+
'\n    <span class="glyphicon glyphicon-remove clickable remove-relation" rel-id="'+
((__t=( id ))==null?'':__t)+
'"/>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/relations/relation-item.html
// module id = 235
// module chunks = 0